import md5 from 'blueimp-md5'
import {sha256} from "js-sha256";

export async function setupRedditPixel(event, name, data) {
  ;(function (w, d) {
    if (!w.rdt) {
      const p = w.rdt = function () {
        p.sendEvent
          ? p.sendEvent.apply(p, arguments)
          : p.callQueue.push(arguments)
      }
      p.callQueue = []
      const t = d.createElement('script')
      t.src = 'https://www.redditstatic.com/ads/pixel.js'
      t.async = true
      const s = d.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(t, s)

      const email = window.localStorage.getItem('email')

      window.rdt('init', 'a2_gzjiyabjbf36', {
        email: email ? md5(email.trim().toLowerCase()) : undefined,
        // phoneNumber: '<PHONE-NUMBER-HERE>',
        // externalId: window.localStorage.getItem('uid'),
        externalId: sha256(window.session_uid),
        // idfa: '<IDFA-HERE>',
        // aaid: '<AAID-HERE>',
      })

      // window.rdt('track', 'PageVisit')
    }
  })(window, document)

  if (event) {
    if (data.currency && data.currency !== 'EUR') {
      try {
        const {to, converted} =
          await (
            await fetch(
              `${process.env.REACT_APP_API_URI}info/convert`,
              {
                method: 'POST',
                body: JSON.stringify({
                  value: data.value,
                  from: data.currency,
                  to: 'EUR',
                })
              }
            )
          ).json()

        data.currency = to
        data.value = +converted
      } catch (ex) {
        console.error('catched error:', ex)
      }
    }

    window.rdt(event, name, {
      reddit_click_id: window.localStorage.getItem('rdclid'),
      conversionId: sha256(`${name}_${window.session_uid}`),
      ...data
    })
  }
}